import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  toggleLoginStatus,
  toggleNavigatePanel,
  toggleSignUpStatus,
} from "../../../../REDUX/RegistrationModalToggle/toggleModal";
import { ChoooseNavCategory } from "../../../Products/HandleProductFilter";
import { ProductCategory } from "../../../../utils/ProduArrs";

const NavigatePanel = ({ NavigatePanelModal }) => {
  const dispatch = useDispatch();
  const [showCateDropDown, setshowCateDropDown] = useState(false);

  function showLogin() {
    dispatch(toggleLoginStatus());
  }
  function signUp() {
    dispatch(toggleSignUpStatus());
  }
  function RemNavigatePanelModalFUnc() {
    dispatch(toggleNavigatePanel());
  }
  const { currentUser } = useSelector((state) => state.User);

  /* algorith that dispatch category pick by user */
  function ChoooseNavCategoryClick(e) {
    ChoooseNavCategory(e, dispatch);
  }

  /* this function remove the popUp */
  function removePop() {
    dispatch(toggleNavigatePanel());
  }
  return (
    <div
      className={`fixed inset-y-0  left-0 w-screen h-screen flex items-center z-[999] bg-[#F5FAFF] duration-300 transform transition ease-out  md:hidden
      ${NavigatePanelModal ? "translate-x-0" : "-translate-x-full"} 
    `}
    >
      <div className=" mx-14 w-full">
        <p
          onClick={RemNavigatePanelModalFUnc}
          className=" absolute right-10 top-20"
        >
          <i className="bi bi-x text-4xl font-bolder text-[#007BFF]"></i>
        </p>
        {currentUser && (
          <div>
            <div onClick={() => setshowCateDropDown(!showCateDropDown)}>
              <div className="flex justify-between items-center my-7">
                <p className="text[#272222] font-workSans text-[16px] cursor-pointer">
                  Categories
                </p>
                <i className="bi bi-chevron-right"></i>
              </div>
              {/* categoris list */}
              {showCateDropDown && (
                <ul className="mx-3" onClick={removePop}>
                  {ProductCategory.map((cat) => (
                    <li
                      onClick={ChoooseNavCategoryClick}
                      className="font-workSans cursor-pointer text-[#272222] my-1 font-light"
                    >
                      {cat}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div onClick={removePop}>
              <Link to="/Dashboard">
                <p className="text[#272222] font-workSans text-[16px] my-7">
                  My Profile
                </p>
              </Link>
              <Link to="Dashboard/AccountSettings">
                <p className="text[#272222] font-workSans text-[16px] my-7">
                  Account Settings
                </p>
              </Link>
              <p className="text[#272222] font-workSans text-[16px] my-7">
                Purchase History
              </p>
              <p className="text[#272222] font-workSans text-[16px] my-7">
                My Shop
              </p>
              <Link to="Dashboard/my_payment">
                <p className="text[#272222] font-workSans text-[16px] my-7">
                  Payments
                </p>
              </Link>
            </div>
          </div>
        )}

        {!currentUser && (
          <div className="w-full md:px-10">
            <button
              onClick={showLogin}
              className="block uppercase mx-auto shadow bg-[#007BFF] hover:bg-indigo-700 focus:shadow-outline focus:outline-none text-white text-xs py-3 px-10 rounded-full text-[16px] w-full font-workSans"
            >
              Login
            </button>
            <p className="text[#272222] font-workSans text-[16px] my-3 text-center">
              Or
            </p>
            <button
              onClick={signUp}
              className="block uppercase mx-auto shadow bg-[#007BFF] hover:bg-indigo-700 focus:shadow-outline focus:outline-none text-white text-xs py-3 px-10 rounded-full text-[16px] w-full font-workSans"
            >
              Register
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NavigatePanel;
